
	import { reaction } from 'mobx';
	import { Observer } from 'mobx-vue';
	import { Component, Vue } from 'vue-property-decorator';
	import Modal from '@/components/Modal.vue';
	import Cookies from 'js-cookie';

	@Observer
	@Component({
		components: {
			Modal
		}
	})
	export default class TokenExpiredMessage extends Vue {
		private modal: boolean = false;
		private title: string = 'Security Notification';
		private message: string = '';
		private buttonText: string = 'Stay signed in';
		private needLogin: boolean = false;
		private timer: number = 60;
		private t: number = 0;

		created() {
			reaction(
				() => [this.$state.utils.inactivityLogout, this.$state.utils.automaticLogout, this.$state.utils.criticalAutomaticLogout],
				(val) => {
					if (val[0]) {
						this.inactivityHandler();
						return;
					}
					if (val[1]) {
						if (this.$state.currentRoute == '/index') {
							this.automaticLogoutHandler();
						} else {
							reaction(
								() => this.$state.currentRoute,
								(val) => {
									if (val == '/index') this.automaticLogoutHandler();
								}
							);
						}
					}
					if (val[2]) {
						this.automaticLogoutHandler();
						return;
					}
				}
			);
		}

		private reset() {
			this.modal = false;
			this.title = 'Security Notification';
			this.message = '';
			this.timer = 60;

			clearTimeout(this.t);

			this.$state.utils.inactivityLogout = false;
			this.$state.utils.automaticLogout = false;

			if (this.needLogin) this.logout();
		}

		private async logout() {
			Cookies.remove('mobile-app-redirect-data');
			localStorage.removeItem('storeID');
			localStorage.removeItem('refresh_token');
			localStorage.removeItem('refresh_expiration');
			await this.$state.engine.auth.logout();
		}

		private timerHandler() {
			const t = () => {
				if (this.timer <= 0) {
					clearTimeout(this.t);
					this.logout();
				} else {
					this.t = setTimeout(() => {
						this.timer--;
						t();
					}, 1000);
				}
			};

			t();
		}

		private inactivityHandler() {
			this.modal = true;
			this.message = 'Due to inactivity your session will end in';
			this.buttonText = 'Stay signed in';
			this.needLogin = false;

			this.timerHandler();
		}

		private automaticLogoutHandler() {
			this.modal = true;
			this.message = `We are approaching the maximum time our application may remain in continuous use to meet
			HIPPA compliance. Please Sign in again to refresh your session.
			\n \n You will be automatically signed out in `;
			this.buttonText = 'Sign in';
			this.needLogin = true;

			this.timerHandler();
		}
	}
